/**
 * Shared parallax plugin — any element with data-parallax.
 *
 * Attributes:
 *   data-parallax          enable (presence or "true")
 *   data-parallax-from     start translate (default -15)
 *   data-parallax-to       end translate (default 0)
 *   data-parallax-axis     "y" | "x" (default "y")
 *   data-parallax-unit     "%" | "px" (default "%")
 *   data-parallax-root     optional CSS selector for scroll root
 */
(function () {
  'use strict';

  var ATTR = 'data-parallax';
  var INIT_KEY = 'hpParallaxInit';
  var instances = [];
  var ticking = false;
  var reducedMotion = false;
  var listenersBound = false;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function parseNumber(value, fallback) {
    var n = parseFloat(value);
    return isNaN(n) ? fallback : n;
  }

  function resolveRoot(el) {
    var selector = el.getAttribute('data-parallax-root');
    if (selector) {
      var found = el.closest(selector);
      if (found) return found;
      found = document.querySelector(selector);
      if (found && found.contains(el)) return found;
    }
    return el.closest('.shopify-section') || el.parentElement || el;
  }

  function readConfig(el) {
    return {
      el: el,
      from: parseNumber(el.getAttribute('data-parallax-from'), -15),
      to: parseNumber(el.getAttribute('data-parallax-to'), 0),
      axis: (el.getAttribute('data-parallax-axis') || 'y').toLowerCase() === 'x' ? 'x' : 'y',
      unit: el.getAttribute('data-parallax-unit') === 'px' ? 'px' : '%',
      root: resolveRoot(el)
    };
  }

  function applyTransform(item, value) {
    var unit = item.unit;
    if (item.axis === 'x') {
      item.el.style.transform = 'translate3d(' + value + unit + ', 0, 0)';
    } else {
      item.el.style.transform = 'translate3d(0, ' + value + unit + ', 0)';
    }
  }

  function updateAll() {
    var windowHeight = window.innerHeight;
    var pending = [];

    for (var i = 0; i < instances.length; i++) {
      var item = instances[i];
      if (!item.el.isConnected) continue;

      if (reducedMotion) {
        pending.push({ item: item, value: item.to });
        continue;
      }

      var rect = item.root.getBoundingClientRect();
      if (rect.top < windowHeight && rect.bottom > 0) {
        var scrollProgress = (windowHeight - rect.top) / (windowHeight + rect.height);
        if (scrollProgress < 0) scrollProgress = 0;
        if (scrollProgress > 1) scrollProgress = 1;
        pending.push({ item: item, value: item.from + scrollProgress * (item.to - item.from) });
      }
    }

    for (var j = 0; j < pending.length; j++) {
      applyTransform(pending[j].item, pending[j].value);
    }

    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      window.requestAnimationFrame(updateAll);
      ticking = true;
    }
  }

  function onMotionChange(event) {
    reducedMotion = event.matches;
    requestTick();
  }

  function bindListeners() {
    if (listenersBound) return;
    listenersBound = true;

    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', requestTick, { passive: true });

    if (window.matchMedia) {
      var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (mq.addEventListener) {
        mq.addEventListener('change', onMotionChange);
      } else if (mq.addListener) {
        mq.addListener(onMotionChange);
      }
    }
  }

  function collect() {
    var nodes = document.querySelectorAll('[' + ATTR + ']');
    var next = [];

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var raw = el.getAttribute(ATTR);
      if (raw !== null && raw !== '' && raw !== 'true') continue;
      next.push(readConfig(el));
    }

    instances = next;
  }

  function init() {
    reducedMotion = prefersReducedMotion();
    collect();
    bindListeners();
    requestTick();
  }

  if (!window[INIT_KEY]) {
    window[INIT_KEY] = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  }
})();
